<form [formGroup]="configurationFormFinance">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="dataSelectionType"
        class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.finance.form-fields.data-selection-type'
        | translate}}</label>
      <app-enum-drop-down-list formControlName="dataSelectionType" [showClearButton]="false"
        [enumType]="FinanceDataSelectionType" baseTranslationString='i18n.shared.financeDataSelectionTypes.'>
      </app-enum-drop-down-list>
      <app-error-messages [control]="configurationFormFinance.get('dataSelectionType')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="schedule"
        class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.finance.form-fields.time-schedule'
        | translate}}</label>
      <app-enum-drop-down-list formControlName="schedule" [showClearButton]="false"
        [enumType]="Schedule" baseTranslationString='i18n.shared.financeSchedules.'>
      </app-enum-drop-down-list>
      <app-error-messages [control]="configurationFormFinance.get('schedule')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="sendEmptyData"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.finance.form-fields.send-empty-data'
        |
        translate}}</label>
      <app-yes-no-group-button id="sendEmptyData" formControlName="sendEmptyData"></app-yes-no-group-button>
    </div>
  </div>
</form>